module.exports = __webpack_public_path__ + "img/0007.156d5eb0.jpg";